




import Vue from 'vue';
import CommonNotFound from '@/components/common/common-not-found.component.vue';

export default Vue.extend({
  components: {
    'common-not-found': CommonNotFound
  }
});
